<script lang="ts">
    import Select from 'svelte-select';
    import Employee from '../../../Models/Employee';
    import { PICKED_DATE_RANGE_FOR_REPORT, PICKED_EMPLOYEE_TO_REPORT } from '../../../Stores/Report';
    import ShortSummary from '../EmployeePurchasesReport/ShortSummary.svelte';

    export let slideIndex;

    let employees = {};
    let items;
    let pickedEmployeeID;
    let value;

    function handlePickEmployee(e?) {
        if (e) pickedEmployeeID = e.detail.value;
        PICKED_EMPLOYEE_TO_REPORT.set(employees[pickedEmployeeID]);
    }

    PICKED_DATE_RANGE_FOR_REPORT.subscribe(async (range: { start: string, end: string }) => {
        const res = await Employee.getAll();

        items = res.map(employee => {
            return {
                label: `${employee.firstname} ${employee.lastname}`,
                value: employee._id
            }
        })

        res.forEach(async employee => {
            const purchasesSummary = await Employee.getPurchasesSummary(employee._id, range.start, range.end);
            const { _id, firstname, lastname, role } = employee;
            employees[employee._id] = {
                _id,
                firstname,
                lastname,
                purchasesSummary,
                role
            };
            handlePickEmployee();
        })
    })

    PICKED_EMPLOYEE_TO_REPORT.subscribe(employee => {
        if (employee) slideIndex = 1;
    });
</script>

{#if slideIndex == 0}
    <Select
        on:select={handlePickEmployee}
        bind:value
        {items}
        placeholder="Wybierz pracownika z listy..."
        containerStyles="min-width: 350px"
        listOutsideParentContainer
    />
{/if}
{#if slideIndex == 1}
    <section class="modalContent">
        <ShortSummary />
    </section>
{/if}
